/**文献对比更新抽屉 */
<template>
  <el-drawer
    v-model="DWRVisible"
    :before-close="closeDWR"
    modal-class="update-comparison-drawer"
    :size="DWRType == 'UPDATE' ? '60%' : '30%'"
  >
    <template #header>
      <DrawerHeader :DWRTitle="DWRTitle"></DrawerHeader>
    </template>
    <template #default>
      <div class="drawer-update-comparison">
        <div class="comparison-header">
          <div class="title">
            标题：
            <span>{{ literatureInfo.title }}</span>
          </div>
          <div class="authors">
            作者：
            <span>{{ literatureInfo.authors || "--" }}</span>
          </div>
        </div>
        <div class="comparison-update">
          <div
            class="read-content"
            :style="pageLoading ? 'height: calc(100vh - 120px - 50px)' : ''"
            v-if="DWRType == 'UPDATE'"
            v-loading="pageLoading"
            element-loading-text="AI阅读信息获取中..."
          >
            <div class="read-header">
              <div class="title">AI阅读信息</div>
              <el-button class="button" @click="handleClickUpdateAll">
                <i class="iconfont icon-jichu_gengxin" />
                一键更新
              </el-button>
            </div>
            <div class="read-item" v-for="item in readItems" :key="item.name">
              <div class="item-header">
                <img
                  :src="
                    AI_READING_TYPE_IMAGE[item.name] ||
                    AI_READING_TYPE_IMAGE['custom']
                  "
                  class="item-img"
                />
                <span class="item-title">{{ item.label }}</span>
                <el-tooltip content="更新到对比" placement="top" effect="dark">
                  <span
                    class="item-icon"
                    @click="handleClickUpdateItem(item.name)"
                    v-show="showUpdateButton(item.name)"
                  >
                    <i class="iconfont icon-jichu_gengxin" />
                  </span>
                </el-tooltip>
              </div>
              <div class="item-content">
                <div class="content">
                  {{ readData[item.name] || "无" }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="comparison-content"
            :style="DWRType == 'UPDATE' ? 'padding: 10px;' : ''"
          >
            <div class="comparison-title" v-if="DWRType == 'UPDATE'">
              文献对比信息
            </div>
            <div
              class="comparison-item"
              v-for="item in comparisonItems"
              :key="item.name"
            >
              <div class="item-header">
                <img
                  :src="
                    AI_READING_TYPE_IMAGE[item.name] ||
                    AI_READING_TYPE_IMAGE['custom']
                  "
                  class="item-img"
                />
                <span class="item-title">{{ item.label }}</span>
                <el-tooltip content="还原" placement="top" effect="dark">
                  <span
                    class="item-icon"
                    @click="handleClickRestoreItem(item.name)"
                    v-show="showRestoreButton(item.name)"
                  >
                    <i class="iconfont icon-huanyuan" />
                  </span>
                </el-tooltip>
              </div>
              <div class="item-content">
                <div
                  class="edit"
                  v-if="updateComparisonData[item.name].ifEditing"
                >
                  <el-input
                    v-model="updateComparisonData[item.name].data"
                    ref="editRef"
                    :rows="5"
                    type="textarea"
                    placeholder="请输入"
                    resize="none"
                    @blur="cancelEdit"
                  />
                </div>
                <div
                  class="content"
                  :class="
                    !updateComparisonData[item.name].data ? 'placeholder' : ''
                  "
                  @click="handleClickEdit(updateComparisonData[item.name])"
                  v-else
                >
                  {{ updateComparisonData[item.name].data || "请输入" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div>
        <el-button
          type="primary"
          class="footer-button"
          @click="handleClickSave"
          :loading="saveButtonLoading"
        >
          {{ DWRType == "UPDATE" ? "确认更新" : "保存" }}
        </el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script setup>
import { ref, nextTick, defineExpose, computed, defineEmits } from "vue";
import DrawerHeader from "@/components/base/DrawerHeader.vue";
import { COMPARE_TITLE_TYPE } from "@/constant/compare.js";
import { AI_READING_TYPE_IMAGE } from "@/constant/ai_reading_type.js";
import { httpPost } from "@/api/httpService";
import { ElMessage } from "element-plus";

const emits = defineEmits(["refresh"]);

// #region弹窗相关
const DWRVisible = ref(false);
const DWRTitle = ref("详情");
const DWRType = ref("DETAIL");
const literatureUid = ref("");
const literatureInfo = ref({ title: "", authors: "" });
const comparisonUid = ref("");
const originalComparisonData = ref({}); //比较项数据（原始数据）
const updateComparisonData = ref({}); //比较项数据（更新数据）
const comparisonItems = ref([]); //比较项列表
const readData = ref({}); //阅读分析数据
const readItems = ref([]); //阅读分析项
const openDWR = (params) => {
  DWRVisible.value = true;
  DWRType.value = params.type;
  literatureUid.value = params.data.literatureUId;
  literatureInfo.value.title = params.data.title;
  literatureInfo.value.authors = params.data.authors;
  comparisonUid.value = params.comparisonUid;
  comparisonItems.value = params.comparisonItems.map((item) => {
    return { name: item.name, label: item.label, type: item.type };
  });
  //要显示的数据
  const data = JSON.parse(JSON.stringify(params.data));
  comparisonItems.value.forEach(({ name }) => {
    if (data[name]) {
      originalComparisonData.value[name] = data[name];
    }
  });
  updateComparisonData.value = JSON.parse(
    JSON.stringify(originalComparisonData.value)
  );
  if (DWRType.value == "UPDATE") {
    getReadData();
  }
};
const closeDWR = () => {
  cancelEdit();
  DWRVisible.value = false;
  readItems.value = [];
  readData.value = {};
};
// #endregion弹窗相关

//获取文献分析数据
const pageLoading = ref(false);
const getReadData = async () => {
  pageLoading.value = true;
  let params = {
    literatureUid: literatureUid.value,
  };
  let res = await httpPost("/reading/v1/searchReadResult", params);
  if (res.code == 0) {
    readItems.value = comparisonItems.value.filter(
      (item) => item.type == COMPARE_TITLE_TYPE.SYSTEM
    );
    const readResult = res.data.readResult;
    //根据阅读分析项获取特定结构的数据
    readItems.value.forEach((item) => {
      if (readResult[item.name] !== undefined) {
        readData.value[item.name] = readResult[item.name];
      }
    });
  }
  pageLoading.value = false;
};
//控制显示更新按钮
const showUpdateButton = computed(() => {
  //只要文献对比当前数据跟文献分析数据不等，则显示更新按钮
  return (name) => {
    return updateComparisonData.value[name].data != readData.value[name];
  };
});
//控制显示还原按钮
const showRestoreButton = computed(() => {
  //只要文献对比当前数据跟文献对比原始数据不等，则显示还原按钮
  return (name) => {
    return (
      updateComparisonData.value[name].data !=
      originalComparisonData.value[name].data
    );
  };
});
//一键更新
const handleClickUpdateAll = () => {
  readItems.value.forEach((item) => {
    updateComparisonData.value[item.name].data = readData.value[item.name];
  });
};
//更新单个
const handleClickUpdateItem = (name) => {
  updateComparisonData.value[name].data = readData.value[name];
};
//还原单个
const handleClickRestoreItem = (name) => {
  updateComparisonData.value[name].data =
    originalComparisonData.value[name].data;
};
//编辑
const editRef = ref(null);
const focusInput = () => {
  //如果当前有输入框
  if (editRef.value) {
    editRef.value[0].focus();
  }
};
const handleClickEdit = (item) => {
  cancelEdit();
  item.ifEditing = true;
  nextTick(() => {
    focusInput();
  });
};
const cancelEdit = () => {
  //将其他正在编辑的取消编辑
  for (let key in updateComparisonData.value) {
    updateComparisonData.value[key].ifEditing = false;
  }
};
//保存修改
const saveButtonLoading = ref(false);
const handleClickSave = async () => {
  saveButtonLoading.value = true;
  //处理要传的入参
  let updateArray = Object.values(updateComparisonData.value).map((item) => ({
    title: item.title,
    content: item.data,
  }));
  let isNeedUpdateCompareTime;
  if (DWRType.value == "UPDATE") {
    isNeedUpdateCompareTime = true;
  } else {
    isNeedUpdateCompareTime = false;
  }
  let params = {
    comparisonUid: comparisonUid.value,
    literatureUid: literatureUid.value,
    modifyDataList: updateArray,
    isNeedUpdateCompareTime,
  };
  let res = await httpPost("/comparison/v1/updateComparison", params);
  if (res.code == 0) {
    ElMessage.success("更新成功");
    closeDWR();
    refresh();
  }
  saveButtonLoading.value = false;
};

//更新
const refresh = () => {
  emits("refresh");
};

defineExpose({ openDWR, closeDWR });
</script>

<style lang="scss" scoped>
.drawer-update-comparison {
  padding: 15px 15px 0 15px;
  .comparison-header {
    color: #848486;
    text-align: left;
    .title {
      line-height: 22px;
    }
    .authors {
      margin-top: 10px;
    }
  }
  .comparison-update {
    display: flex;
    margin-top: 15px;
    .read-content {
      border: 2px dashed #e4e4e4;
      border-radius: 5px;
      padding: 10px;
      flex: 1;
      .read-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        height: 25px;
        .title {
          text-align: left;
          color: #383838;
          font-weight: 550;
        }
        .button {
          position: relative;
          top: -3px;
          border: none;
          color: #848486;
          font-size: 13px;
          height: 28px;
          width: 80px;
          .iconfont {
            font-size: 13px;
            margin-right: 5px;
          }
        }
        .button:hover {
          background-color: #f5f5f5;
        }
      }
      .read-item {
        text-align: left;
        margin: 10px 0 20px 0;
        .item-header {
          .item-img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            display: inline-block;
            vertical-align: middle;
          }
          .item-title {
            color: #383838;
            font-weight: 550;
            margin-right: 10px;
          }
          .item-icon {
            visibility: hidden;
            cursor: pointer;
            padding: 2px;
            border-radius: 4px;
            .iconfont {
              color: #bcbcbc;
              font-size: 13px;
            }
          }
          .item-icon:hover {
            background-color: #f5f5f5;
          }
        }
        .item-content {
          padding: 5px 0;
          .content {
            overflow-y: auto;
            height: 150px;
            color: #585858;
            font-size: 13px;
            padding: 10px;
            border-radius: 5px;
            line-height: 22px;
            @include paragraph();
          }
        }
      }
      .read-item:hover {
        .item-header {
          .item-icon {
            visibility: visible;
          }
        }
      }
    }
    .comparison-content {
      // padding: 10px;
      flex: 1;
      .comparison-title {
        text-align: left;
        color: #383838;
        font-weight: 550;
        margin-bottom: 10px;
        height: 25px;
      }
      .comparison-item {
        text-align: left;
        margin: 10px 0 20px 0;
        .item-header {
          .item-img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            display: inline-block;
            vertical-align: middle;
          }
          .item-title {
            color: #383838;
            font-weight: 550;
            margin-right: 10px;
          }
          .item-icon {
            visibility: hidden;
            cursor: pointer;
            padding: 2px;
            border-radius: 4px;
            .iconfont {
              color: #bcbcbc;
              font-size: 13px;
            }
          }
          .item-icon:hover {
            background-color: #f5f5f5;
          }
        }
        .item-content {
          padding: 5px 0;
          .edit {
            :deep(.el-textarea__inner) {
              font-size: 13px;
              box-shadow: none;
              border: 1px solid $theme-color;
              height: 150px;
            }
          }
          .content {
            height: 150px;
            overflow-y: auto;
            color: #585858;
            font-size: 13px;
            cursor: pointer;
            padding: 10px;
            border-radius: 5px;
            line-height: 22px;
            @include paragraph();
            background-color: #ffffff;
          }
          .placeholder {
            color: #bcbcbc;
          }
          .content:hover {
            background-color: #f6f6f6;
          }
        }
      }
      .comparison-item:hover {
        .item-header {
          .item-icon {
            visibility: visible;
          }
        }
      }
    }
  }
}
.footer-button {
  height: 30px;
}
</style>
